import styles from './index.module.scss';

const SysText = ({
  children,
  textColor = 'gray',
  noStyle = false,
}: {
  children: React.ReactNode;
  textColor?: 'black' | 'gray';
  noStyle?: boolean;
}) => {
  return (
    <div
      className={cls(
        styles.sysText,
        noStyle ? styles.ellipsis : styles.textSysText,
        styles[textColor]
      )}
    >
      {children}
    </div>
  );
};

export default SysText;
